var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"795Q9y6hHtiMniPaZuMj4"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["pangobooks@pangobooks-90"]={id:"795Q9y6hHtiMniPaZuMj4"};
      